import React from 'react'
import _cx from 'classnames/bind'
// @ts-ignore no types
import { Text, Icon } from '@adc/ui-adc'
// @ts-ignore no types
import cls from './styles.scss'
const cx = _cx.bind(cls)

const Header = ({
  subText,
  text,
  color,
  icon,
  containerClassName = '',
}: {
  subText?: React.ReactNode
  text: React.ReactNode
  color: string
  icon: React.ReactNode
  containerClassName?: string
}) => {
  return (
    <div
      className={cx('container', containerClassName)}
      data-elm-id='bid_banner_header'
    >
      {icon && icon}
      <div className={cx('u-ml-2', 'flex-child')}>
        <Text
          className={cx('u-mb-1')}
          size='huge'
          color={color}
          content={text}
          data-elm-id='header_text'
        />
        {subText && (
          <Text
            color='gray'
            content={subText}
            data-elm-id='header_sub_text'
            size='small'
          />
        )}
      </div>
    </div>
  )
}

const IconExclamation = (props: any) => {
  return (
    <Icon
      data-elm-id='header_icon_exclamation'
      color='caution'
      fitted
      iconStyle='regular'
      name='exclamation-circle'
      size='big'
      {...props}
    />
  )
}

const IconCheck = (props: any) => {
  return (
    <Icon
      data-elm-id='header_icon_check'
      color='success'
      fitted
      iconStyle='regular'
      name='check-circle'
      size='big'
      {...props}
    />
  )
}

const IconGavel = (props: any) => {
  return (
    <Icon
      data-elm-id='header_icon_gavel'
      color='success'
      fitted
      iconStyle='regular'
      name='gavel'
      size='big'
      {...props}
    />
  )
}

const IconSmile = (props: any) => {
  return (
    <Icon
      data-elm-id='header_icon_smile'
      color='success'
      fitted
      iconStyle='regular'
      name='smile'
      size='big'
      {...props}
    />
  )
}

Header.IconExclamation = IconExclamation
Header.IconCheck = IconCheck
Header.IconGavel = IconGavel
Header.IconSmile = IconSmile

export default Header
